// Note: The Newsletter signup component is split up because there are too many differences

const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const NewsletterSignup = require(`./NewsletterSignup.${brand}`).default;

export default NewsletterSignup;
